import React from 'react';
import { supplies, faqImage } from '../mock';
import Seo from '../components/Seo';

const Supplies = () => {
  return (
    <main className="max-w-[1200px] mx-auto px-6 md:px-10 pt-16 pb-16">
      <Seo
        title="Research Supplies & Bench Kit | Vial Rat Research Co."
        description="A curated list of laboratory supplies and bench-kit items commonly used in research settings. Canadian based, plain packaging."
        canonicalPath="/supplies"
      />
      <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-4">BENCH KIT</div>
      <h1 className="font-serif-display text-white text-6xl md:text-7xl">Supplies</h1>
      <p className="mt-6 text-neutral-400 max-w-2xl">The bits and pieces researchers keep on hand. We don't stock these ourselves — these are the Amazon items we point people to.</p>

      <img src={faqImage} alt="Bench" className="mt-10 rounded-xl border border-white/10 w-full max-h-[380px] object-cover" />

      {Object.entries(supplies).map(([section, items]) => (
        <div key={section} className="mt-16">
          <div className="font-mono-label text-[11px] text-[#ff2fa1] mb-6">{section}</div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map(s => (
              <a key={s.title} href={s.url} target="_blank" rel="noreferrer" className="product-card block bg-[#101013] border border-white/5 rounded-lg overflow-hidden p-5">
                <div className="aspect-square bg-white rounded overflow-hidden">
                  <img src={s.img} alt={s.title} className="w-full h-full object-contain" />
                </div>
                <div className="mt-5 font-serif-display text-white text-lg leading-snug">{s.title}</div>
                <p className="mt-3 text-sm text-neutral-400">{s.desc}</p>
                <div className="mt-4 font-mono-label text-[10px] text-[#ff2fa1]">VIEW ON AMAZON →</div>
              </a>
            ))}
          </div>
        </div>
      ))}

      <p className="mt-16 text-xs text-neutral-500 italic">Affiliate Disclosure: As an Amazon Associate I earn from qualifying purchases. This doesn't change the price you pay.</p>

      <div className="mt-10 p-6 border border-[#ff2fa1]/20 bg-[#ff2fa1]/5 rounded">
        <div className="font-mono-label text-[11px] text-[#ff2fa1]">FOR RESEARCH USE ONLY</div>
        <p className="text-sm text-neutral-400 mt-2">Products are intended for laboratory and research purposes only. Not for human or veterinary use, food, or household application.</p>
      </div>
    </main>
  );
};

export default Supplies;
